import { Badge, Card } from 'corso-admin-ui';
import { isDenial, useClaim } from '~/features/claimReview/ClaimReviewProvider';
import ClaimLineItem from './ClaimLineItem';
import ClaimLineItemActions from './ClaimLineItemActions';
import ClaimLineItemDetails from './ClaimLineItemDetail';
import ClaimLineItemFees from './ClaimLineItemFees';
import ClaimLineItemNoteToCustomer from './ClaimLineItemNoteToCustomer';
import {
  computeDisplayResolutionMethod,
  ExchangeForDetail,
  UpsellBadge,
  wasLineItemZeroedThroughDeduction,
} from './claimLineItemPresentation';
import CustomerMedia from './CustomerMedia';
import Inspection from './Inspection';

export function ClaimLineItemCard({
  claimLineItem,
}: {
  claimLineItem: ReturnType<typeof useClaim>['claimLineItems'][number];
}) {
  const isDenied = isDenial(claimLineItem);
  const claim = useClaim();
  const wasResolvedExternally = !!claimLineItem.wasResolvedExternally;
  const zeroedThroughDeduction = wasLineItemZeroedThroughDeduction(
    claim,
    claimLineItem,
  );

  return (
    <Card key={claimLineItem.id}>
      <div className="flex items-center justify-between gap-2">
        <div className="inline-flex items-center gap-2">
          <Card.Heading>
            {computeDisplayResolutionMethod(
              claimLineItem,
              zeroedThroughDeduction,
            )}
          </Card.Heading>

          {!isDenied && <UpsellBadge claimLineItem={claimLineItem} />}
          {isDenied && <Badge variant="danger">Denied</Badge>}
          {claimLineItem.canceledOn && <Badge>Canceled</Badge>}
          {claimLineItem.wasOutsideEligibilityWindow && (
            <Badge variant="warning">Outside Eligibility Window</Badge>
          )}
          {wasResolvedExternally && (
            <Badge variant="info">Resolved Outside Corso</Badge>
          )}

          {/* todo: refine how we indicate this, potentially using the edit resolution dialog to indicate amount applied */}
          {zeroedThroughDeduction && (
            <Badge variant="warning">Credit Applied To Replacement Order</Badge>
          )}
        </div>

        <ClaimLineItemActions claimLineItem={claimLineItem} />
      </div>

      <ClaimLineItem claimLineItem={claimLineItem} />

      <ExchangeForDetail claimLineItem={claimLineItem} />
      <ClaimLineItemFees
        claimLineItemId={claimLineItem.id}
        fees={claimLineItem.fees}
      />

      <ClaimLineItemDetails claimLineItem={claimLineItem} />
      <ClaimLineItemNoteToCustomer claimLineItem={claimLineItem} />
      <CustomerMedia claimLineItem={claimLineItem} />
      <Inspection claimLineItem={claimLineItem} />
    </Card>
  );
}
